<template>
  <!-- 分包商专业 -->
  <div class="fourthStep">
    <el-form
      ref="extTable"
      :model="{ extTable }"
      :rules="tableRules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item
        style="width:751px; !important"
        class="addTabIndex"
        label-width="0px"
        label=""
        prop=""
      >
        <el-table
          border
          :data="extTable"
          class="ccui-form-child-table"
          max-height="99999"
        >
          <el-table-column prop="remark" label="一级名称">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.subjectTopName`"
                :rules="tableRules.subjectTopName"
              >
                <el-input
                  @click.native="getLeven(scope.row)"
                  style="cursor: pointer !important; width: 250px"
                  v-model="scope.row.subjectTopName"
                  placeholder="请输入"
                  clearable
                  maxlength="255"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :show-overflow-tooltip="true"
            prop="remark"
            label="二级名称"
          >
            <template slot-scope="scope">
              {{ scope.row.subjectName }}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="130px;"
            align="center"
            :show-overflow-tooltip="true"
            prop="remark"
            label="操作"
          >
            <template slot-scope="scope">
              <span
                style="color: red; cursor: pointer"
                @click="deleteItem(scope)"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label-width="0px" label="">
        <div class="addBtn" @click="addTable()">+添加专业</div>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择分包商专业"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <treeList
        :treeData="listSubconBaseSubjectList"
        ref="msgFormSon"
      ></treeList>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeList from "./treelist.vue";
import { listSubconBaseSubject } from "@/api/subcontractor-register";

export default {
  props: {
    extTable: {
      type: Array,
      default: [],
    },
  },
  components: {
    treeList,
  },
  data() {
    return {
      tableRules: {
        subjectTopName: [
          { required: true, message: "请输入编码", trigger: "change" },
        ],
      },
      centerDialogVisible: false,
      listSubconBaseSubjectList: [],
      selectRow: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    ruleFun() {
      this.$refs["extTable"].validate((valid) => {
        if (valid) {
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
        });
      }
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    getLeven(row) {
      this.centerDialogVisible = true;
      this.selectRow = row;
    },
    getList() {
      listSubconBaseSubject({
        business: "",
        publishStatus: 1,
        attribute1: "true",
        isDelete: 0,
      }).then((res) => {
        this.listSubconBaseSubjectList = res.data.data;
      });
    },
    // 打开组织树
    getTreeItem() {
      let treeItem = this.$refs["msgFormSon"].subjectObj;
      if (!treeItem) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点数据",
          ccuiCustom: true,
        });
        return false;
      }
      this.$set(this.selectRow, "subjectId", treeItem.id);
      this.$set(this.selectRow, "subjectName", treeItem.name);
      this.$set(this.selectRow, "subjectTopId", treeItem.parentId);
      this.$set(this.selectRow, "subjectTopName", treeItem.parentName);
      this.centerDialogVisible = false;
      // console.log(this.ruleForm);
    },
  },
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-form-item__content {
  width: 751px !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 751px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}

.addTabIndex /deep/.el-form-item__content {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 55px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }
}
</style>
